module.exports = __webpack_public_path__ + "img/數位專題集散地-02.5072dddf.jpg";